export const getFileName = (filePath: string) => {
  if (!filePath) {
    return "";
  }
  const lastBackslashIndex = filePath.lastIndexOf("\\");
  const firstUnderscoreIndex = filePath.indexOf("_", lastBackslashIndex);
  return filePath.substring(firstUnderscoreIndex + 1);
};
